module.exports = __webpack_public_path__ + "img/open-close_3month01.3647bc2d.png";